import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Select from "react-select";
import {
  ADD_TEAM,
  LISTE_EQUIPE_COORDO,
  LISTE_EQUIPE_SANS,
} from "../../Utils/constant";
import { store } from "../../services/service";
import { useEquipeStore } from "../../store/EquipeStore";
import { useStoreAgent } from "../../store/agentStore";

export const AddTeam = ({ id }) => {
  const agentData = [];
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [select, setSelect] = useState([]);
  const equipe = useEquipeStore();
  const submit = (data) => {
    setIsSubmit(true);
    store(ADD_TEAM, "application/json", {
      ...data,
      coordinateurId: id,
      listAgentId: select.map((item) => item.value),
    })
      .then((res) => {
        setIsSubmit(false);
        equipe.getEquipePrestataire(
          LISTE_EQUIPE_COORDO + "/" + id + `?param=&page=0&size=10`,
        );
        document.getElementById("add_Team").close();
        reset();
        toast.success("Equipe enregistrée ");
      })
      .catch((err) => {
        console.log(err);
        setIsSubmit(false);
        toast.error("Une erreur est survenue");
      });
  };

  const technicien = useStoreAgent();
  useEffect(() => {
    technicien.technicienSansEquipe(
      `${LISTE_EQUIPE_SANS}?coordinateurId=${id}&page=0&param=&size=10000000000`,
    );
  }, []);

  technicien?.technicienSans?.map((item) => {
    return agentData.push({ value: item.id, label: item.nomPrenoms });
  });

  return (
    <>
      <form onSubmit={handleSubmit(submit)} className="px-2">
        <div className="my-4 space-y-4">
          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Nom de l'equipe <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="nom de l'equipe"
              className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
              {...register("libelle", { required: true })}
            />
            {errors.libelle && (
              <span className="text-sm text-rose-600">
                Ce champs est obligatoire
              </span>
            )}
          </div>

          <div className="my-2">
            <label htmlFor="" className="text-sm font-medium">
              Techniciens <span className="text-red-500">*</span>
            </label>
            <Select
              isMulti
              onChange={(e) => setSelect(e)}
              options={agentData}
            />
          </div>

          <button
            type="submit"
            disabled={isSubmit ? true : false}
            className={`${
              !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
            } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
          >
            {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </>
  );
};
